import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSupportIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="support-icon_svg__Layer_1"
    data-name="Layer 1"
    viewBox="0 0 43.705 38.554"
    {...props}
  >
    <defs>
      <style>
        {
          '.support-icon_svg__cls-1{fill:#fff}.support-icon_svg__cls-2{fill:#003cb2}.support-icon_svg__cls-3{isolation:isolate}'
        }
      </style>
    </defs>
    <path
      id="support-icon_svg__Path_1857"
      d="M656.044 411.105c.01-3.415-6.575-6.277-15.3-6.922l.007-2.57a14.33 14.33 0 0 0 3.577-9.834c0-7.109-4.042-10.659-6.7-10.667-4.4-.013-7.976 4.763-7.994 10.667-.013 4.3 1.871 8.018 4.6 9.721l-.008 2.624c-9.024.5-15.933 3.373-15.944 6.866a2.6 2.6 0 0 0 .037.425 3 3 0 0 0-.039.446l-.02 6.688 37.76.115.02-6.688a3 3 0 0 0-.037-.446 3 3 0 0 0 .041-.425"
      className="support-icon_svg__cls-1"
      data-name="Path 1857"
      transform="translate(-617.759 -380.612)"
    />
    <path
      d="m38.761 38.554-38.76-.12.021-7.187a3 3 0 0 1 .033-.443 3 3 0 0 1-.031-.422c.012-3.684 6.689-6.74 15.946-7.341l.005-1.883c-2.815-1.902-4.611-5.786-4.599-9.993C11.395 5.003 15.196 0 19.852 0h.02c3.017.009 7.198 3.894 7.198 11.167a14.77 14.77 0 0 1-3.578 10.02l-.006 1.923c9.044.752 15.31 3.763 15.3 7.385v.005a3 3 0 0 1-.036.422 3 3 0 0 1 .031.443ZM1.003 37.438l36.76.112.019-6.187a2.3 2.3 0 0 0-.03-.363l-.015-.086.016-.085a2 2 0 0 0 .033-.34c.007-3.034-6.371-5.794-14.836-6.419l-.465-.035.01-3.225.124-.141a13.78 13.78 0 0 0 3.451-9.49c0-6.547-3.666-10.172-6.2-10.18h-.019c-4.107 0-7.459 4.557-7.476 10.169-.012 3.985 1.702 7.633 4.365 9.295l.236.147-.01 3.374-.47.026c-8.666.48-15.463 3.278-15.473 6.37a2 2 0 0 0 .03.338l.014.083-.014.083a2.4 2.4 0 0 0-.032.37Z"
      className="support-icon_svg__cls-2"
    />
    <g id="support-icon_svg__Group_68" data-name="Group 68">
      <path
        id="support-icon_svg__Path_1858"
        d="M661.463 398.072a12 12 0 1 1-12-12 12 12 0 0 1 12 12"
        className="support-icon_svg__cls-2"
        data-name="Path 1858"
        transform="translate(-617.759 -380.612)"
      />
      <g id="support-icon_svg__question" className="support-icon_svg__cls-3">
        <g className="support-icon_svg__cls-3">
          <path
            d="M35.777 15.228c0 2.718-2.936 2.76-2.936 3.764v.136a.56.56 0 0 1-.563.563H30.58a.563.563 0 0 1-.562-.563v-.23c0-1.45 1.098-2.028 1.928-2.494.712-.398 1.149-.67 1.149-1.2 0-.698-.892-1.162-1.613-1.162a2.28 2.28 0 0 0-1.94 1.159.563.563 0 0 1-.779.097l-1.01-.766a.56.56 0 0 1-.122-.77 4.54 4.54 0 0 1 4.034-2.134c1.988 0 4.112 1.553 4.112 3.6m-2.724 6.776a1.624 1.624 0 1 1-1.623-1.623 1.626 1.626 0 0 1 1.623 1.623Z"
            className="support-icon_svg__cls-1"
          />
        </g>
      </g>
    </g>
  </svg>
);
export default SvgSupportIcon;
